var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.comp)?_c(_vm.comp,{ref:"compModel",tag:"component",attrs:{"formData":_vm.formData}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }